<rotec-modal-v2
  [width]="width"
  [height]="height"
  [darkMode]="true"
  [hideModalTitle]="true"
  [disablePaddingMainPart]="true"
>
  <ng-container ngProjectAs="modal-main">
    @if (formGroup) {
      <div class="weight-modal-content">
        <div class="manage-set">
          <div class="weight-modal-title" translate>Weight Settings</div>
          <h2 translate>Manage Weight Set</h2>
          <div class="weight-form">
            <div class="weight-form-row">
              <div class="weight-form-row-title" translate>Number of Weights</div>
              <div class="weight-form-row-input">
                <rotec-number-input-panel-v2
                  [value]="formGroup.get('manageWeights.numWeights').value"
                  [onlyAllowDecimals]="true"
                  [hasError]="formGroup.get('manageWeights.numWeights').errors"
                  [darkMode]="true"
                  (valueChange)="onChangeNumWeights($event)"
                ></rotec-number-input-panel-v2>
                @if (formGroup.get('manageWeights.numWeights')?.errors?.valueRangeError; as error) {
                  <div class="error-message">
                    {{ error.message | translate: { min: error.min, max: error.max } }}
                  </div>
                }
              </div>
            </div>
            <div class="weight-form-row">
              <div class="weight-form-row-title" translate>Weight Increment</div>
              <div class="weight-form-row-input">
                <rotec-number-input-v2
                  [value]="formGroup.get('manageWeights.increment.value').value"
                  [hasError]="formGroup.get('manageWeights.increment.value').errors"
                  [darkMode]="true"
                  [selectedUnit]="formGroup.get('manageWeights.increment.unit').value"
                  [required]="true"
                  [unitType]="'Mass'"
                  (valueChange)="onChangeIncrement($event)"
                ></rotec-number-input-v2>
                @if (!formGroup.get('manageWeights.increment.value')?.errors?.required) {
                  @if (
                    formGroup.get('manageWeights.increment.value')?.errors?.valueRangeError;
                    as error
                  ) {
                    <div class="error-message">
                      {{ error.message | translate: { min: error.min, max: error.max } }}
                    </div>
                  } @else {
                    @if (
                      formGroup.get('manageWeights.increment.value')?.errors?.greaterZeroError;
                      as error
                    ) {
                      <div class="error-message">
                        {{ error | translate }}
                      </div>
                    }
                  }
                }
              </div>
            </div>
            @if (hasManualChanges) {
              <div class="weight-form-row">
                <div class="overwrite-info">
                  <rotec-icon-v2 svgIcon="alarm-none" color="yellow-dark"></rotec-icon-v2>
                  <span translate>Manual changes will be overwritten!</span>
                </div>
              </div>
            }
            <div class="weight-form-row">
              <button
                rotec-button-primary-v2
                dark
                icon="process"
                [showSpinner]="createWeightsProgress$ | async"
                [disabled]="
                  !formGroup.get('manageWeights').valid ||
                  (createWeightsProgress$ | async) ||
                  (incrementValidationChange$ | async)
                "
                (click)="createWeights()"
              >
                <span class="rc-pl-10" translate>Create Weights</span>
              </button>
            </div>
          </div>
        </div>
        <div class="weight-set-table">
          <div class="weight-set-table-header weight-set-table-row">
            <div class="weight-set-table-column" translate>Active</div>
            <div class="weight-set-table-column" translate>Name</div>
            <div class="weight-set-table-column weight-set-table-header-weight">
              <span translate>Weight</span>
              <rotec-icon-v2 svgIcon="chevron-down"></rotec-icon-v2>
            </div>
            <div class="weight-set-table-column"></div>
          </div>
          @if (!weights.length) {
            <div class="empty-text">
              <span translate>
                Adjust start weight or increments to compute weights. Once created, you can adjust
                the weights individually
              </span>
              <button
                rotec-button-active
                dark
                bullet
                icon="update"
                [showSpinner]="createWeightsProgress$ | async"
                [disabled]="
                  !formGroup.get('manageWeights').valid ||
                  (createWeightsProgress$ | async) ||
                  (incrementValidationChange$ | async)
                "
                (click)="createWeights()"
              >
                <span translate>Create Weights</span>
              </button>
            </div>
          }
          @if (weights.length) {
            @for (control of formGroup.get('weights').controls; track control; let i = $index) {
              <div class="weight-set-table-item-row">
                <div class="weight-set-table-column">
                  <rotec-checkbox-v2
                    [status]="control.get('active').value ? 'checked' : 'unchecked'"
                    [darkMode]="true"
                    (statusChange)="toggleActive(control)"
                  ></rotec-checkbox-v2>
                </div>
                <div class="weight-set-table-column">
                  <rotec-text-input-v2
                    [value]="control.get('weight.name').value"
                    [hasError]="control.get('weight.name').errors"
                    [darkMode]="true"
                    [required]="true"
                    [onlyBorderBottom]="true"
                    (valueChange)="onNameChange($event, control)"
                  ></rotec-text-input-v2>
                </div>
                <div class="weight-set-table-column">
                  <rotec-number-input-v2
                    [value]="control.get('weight.value').value"
                    [selectedUnit]="control.get('weight.unit').value"
                    [hasError]="control.get('weight.value').errors"
                    [darkMode]="true"
                    [required]="true"
                    [onlyBorderBottom]="true"
                    [unitType]="'Mass'"
                    (valueChange)="onWeightChange($event, control)"
                  ></rotec-number-input-v2>
                </div>
                <div class="weight-set-table-column">
                  <rotec-icon-v2
                    svgIcon="trash"
                    color="gray-lighter"
                    (click)="deleteWeight(i)"
                  ></rotec-icon-v2>
                </div>
              </div>
            }
            <div class="weight-set-table-row">
              <div class="weight-set-table-column"></div>
              <div class="weight-set-table-column"></div>
              <div class="weight-set-table-column"></div>
              <div class="weight-set-table-column rc-pt-20">
                <rotec-icon-v2 svgIcon="plus" color="blue" (click)="addWeight()"></rotec-icon-v2>
              </div>
            </div>
          }
        </div>
      </div>
    }
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <div class="weight-modal-buttons">
      <button rotec-button-primary-v2 dark (click)="cancel()">
        {{ 'Cancel' | translate }}
      </button>

      <button
        rotec-button-active
        dark
        [disabled]="okButtonDisabled || (disableOkButton$ | async)"
        (click)="save()"
      >
        {{ 'COMMON_Create' | translate }}
      </button>
    </div>
  </ng-container>
</rotec-modal-v2>
